import { createFileRoute } from "@tanstack/react-router";
import { SignInIm } from "@/features/auth/sign-in-im";

export const Route = createFileRoute("/(auth)/sign-in-im")({
  component: SignInIm,
});
